import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { MainContainer } from './styles';
import { COLORS } from '../../../../utils/styles';

const theme = { primaryColor: COLORS.cerulean };

const Root = ({ store, history, routes: Routes }) => (
  <Provider store={store} history={history}>
    <ThemeProvider theme={theme}>
      <MainContainer>
        <Routes history={history} />
      </MainContainer>
    </ThemeProvider>
  </Provider>
);

Root.propTypes = {
  store: PropTypes.objectOf(Object).isRequired,
  history: PropTypes.objectOf(Object).isRequired,
  routes: PropTypes.func.isRequired
};

export default Root;



// WEBPACK FOOTER //
// ./src/views/common/components/Root/index.jsx